import { render, staticRenderFns } from "./MainTabSuccessCustomerCodFeature.vue?vue&type=template&id=b8019420&scoped=true"
import script from "./MainTabSuccessCustomerCodFeature.vue?vue&type=script&lang=js"
export * from "./MainTabSuccessCustomerCodFeature.vue?vue&type=script&lang=js"
import style0 from "./MainTabSuccessCustomerCodFeature.vue?vue&type=style&index=0&id=b8019420&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8019420",
  null
  
)

export default component.exports